module.exports = __webpack_public_path__ + "static/img/yan.eed0636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yan.png
// module id = TJzZ
// module chunks = 1